import { ChangeDetectorRef, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorService } from 'src/app/services/error.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialogComponent  {

  isPerformingAction = false;
  title: string;
  message: string;
  btnOkText: string;
  btnCancelText: string;
  acceptAction:() => Promise<void>;
  files: any[] = [];
  progressBarWidth = 0;

  constructor(private activeModal: NgbActiveModal,
              private errorService: ErrorService,
              private cdr: ChangeDetectorRef) { }


  public onDecline(): void {
    this.activeModal.close(false);
  }

  public async onAccept(): Promise<void> {
    this.isPerformingAction = true;
    if (this.acceptAction) {
      try {
        await this.acceptAction();
        this.activeModal.close(true);
      }
      catch(error) {
        this.errorService.show('Failed to perform the requested action', error);
        this.isPerformingAction = false;
        return;
      }
    }
    this.isPerformingAction = false;
    this.activeModal.close(true);
  }

  public onDismiss(): void {
    this.activeModal.close(false);
    this.activeModal.dismiss();
  }

  get returnUploadFailedNumber() {
    // Use spread operator ... to convert FileList to Array
    const count = [...this.files].filter(x => x.isUploadFailed !== undefined && x.isUploadFailed !== null && x.isUploadFailed == true).length;
    return count;
  }

  returnFileSizeInKB(file) {
    const size = ((Math.round(file.size / 1024)) + ' KB').toString();
    return size;
  }

  isFileUploading() {
    const count = [...this.files].filter(x => x.isFileUploading !== undefined && x.isFileUploading !== null && x.isFileUploading == true).length;
    if (count > 0) {
      this.detectChangeForFileUpload();
      return true;
    }
    this.cdr.detach();
    return false;
  }

  detectChangeForFileUpload() {
    // Angular is not updating the view for file upload changes, so here I'm manually detecting the changes by 'this.cdr.detectChanges();'
    const tempStoreInterval = setInterval(() => {
      this.cdr.detectChanges();
      this.cdr.detach();
      clearInterval(tempStoreInterval);
    }, 2000);
  }

  getFileName(fileName: string): string {
    if(fileName && fileName.length > 0){
      return fileName.toLowerCase();
    }
    else return '';
  }

}
